export const DrawRectangleIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path d="M1.20391 10.082C1.24223 10.4584 1.54163 10.7578 1.91797 10.7961L2 10.8H10L10.082 10.7961C10.4853 10.755 10.8 10.4141 10.8 10V2C10.8 1.55817 10.4418 1.2 10 1.2V0C11.1046 0 12 0.895431 12 2V10C12 11.1046 11.1046 12 10 12H2C0.89543 12 1.28851e-08 11.1046 0 10V2C0 0.89543 0.895431 1.28851e-08 2 0V1.2C1.55817 1.2 1.2 1.55817 1.2 2V10L1.20391 10.082ZM10 0V1.2H2V0H10Z" />
    </svg>
  );
};
